/**
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
 */

import Vue from 'vue';

Vue.prototype.$_UTILS = {
  getRandomInt (min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min; // The maximum is exclusive and the minimum is inclusive
  },

  waitTimeout (ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  },

  isFirefox () {
    return typeof InstallTrigger !== 'undefined';
  },
  isSafari () {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  },
  isChrome () {
    return window.chrome;
  }
};

export const $_UTILS = Vue.prototype.$_UTILS;
